import { render, staticRenderFns } from "./NotificationHistory.vue?vue&type=template&id=34d897d6"
import script from "@/views/NotificationHistory/NotificationHistory.ts?vue&type=script&lang=ts&external"
export * from "@/views/NotificationHistory/NotificationHistory.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/NotificationHistory/notification-history.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports